import {
  IUserManagementState,
  userManagementInitialState,
} from './Interfaces/IUserManagementState';
import { DispatchActions } from './Types/UserManagementDispatchActions';
import { UserManagementActionType } from './Types/UserManagementActionType';

export const UserManagementReducer = (
  state: IUserManagementState,
  action: DispatchActions,
): IUserManagementState => {
  switch (action.type) {
    case UserManagementActionType.SelectAll: {
      return { ...state, selectAll: !state.selectAll };
    }
    case UserManagementActionType.SetRoleFilter:
      return { ...state, filter: { ...state.filter, roles: action.value } };
    case UserManagementActionType.SetSearchFilter:
      return { ...state, filter: { ...state.filter, search: action.value } };
    case UserManagementActionType.SetRetentionStatusFilter:
      return {
        ...state,
        filter: { ...state.filter, retentionStatus: action.value },
      };
    case UserManagementActionType.SetUsers:
      return {
        ...state,
        users: action.users,
      };
    case UserManagementActionType.SetSelectedUsers:
      return {
        ...state,
        selectedUsers: action.value,
      };
    case UserManagementActionType.SelectUsers:
      return {
        ...state,
        selectedUsers: [...state.selectedUsers, ...action.value],
      };
    case UserManagementActionType.ExcludeUsers:
      return { ...state, excludeUsers: action.value };
    case UserManagementActionType.RemoveUsers:
      return {
        ...state,
        selectedUsers: [
          ...state.selectedUsers.filter(
            x => action.value.findIndex(y => x.id === y.id) === -1,
          ),
        ],
      };
    case UserManagementActionType.UpdateUsers:
      return {
        ...state,
        users: state.users.map(x => action.value.find(o => o.id === x.id) || x),
      };
    case UserManagementActionType.Reset:
      return {
        ...state,
        filter: {
          search: '',
          roles: [],
          retentionStatus: [] as number[],
        },
        selectedUsers: state.selectedUsers,
      };
    case UserManagementActionType.SetUserManagementFilters:
      return {
        ...state,
        filter: action.value,
      };
    default:
      return state;
  }
};
